module.exports = __webpack_public_path__ + "media/applicants/android@3x-ac32c5f2.png";